import { n as e } from "./Area-MLM4Xe0E.js";
//#region src/bigmap/Skeleton.ts
var t = [
	"north",
	"northeast",
	"east",
	"southeast",
	"south",
	"southwest",
	"west",
	"northwest",
	"up",
	"down",
	"in",
	"out"
];
//#endregion
//#region src/bigmap/PlaneIndex.ts
function n(e, t, n) {
	let r = [], i = Infinity, a = -Infinity, o = Infinity, s = -Infinity;
	for (let c = 0; c < e.count; c++) {
		if (e.area[c] !== t || e.z[c] !== n) continue;
		r.push(c);
		let l = e.x[c], u = e.y[c];
		l < i && (i = l), l > a && (a = l), u < o && (o = u), u > s && (s = u);
	}
	let c = Int32Array.from(r);
	if (c.length === 0) return {
		indices: c,
		minX: 0,
		minY: 0,
		cs: 1,
		cols: 1,
		rows: 1,
		cellStart: new Int32Array(2),
		order: c,
		bounds: {
			minX: 0,
			maxX: 0,
			minY: 0,
			maxY: 0
		}
	};
	let l = Math.max(a - i, s - o, 1), u = Math.max(1, Math.ceil(l / 128)), d = Math.floor((a - i) / u) + 1, f = Math.floor((s - o) / u) + 1, p = (t) => Math.floor((e.y[t] - o) / u) * d + Math.floor((e.x[t] - i) / u), m = new Int32Array(d * f);
	for (let e = 0; e < c.length; e++) m[p(c[e])]++;
	let h = new Int32Array(d * f + 1);
	for (let e = 0; e < d * f; e++) h[e + 1] = h[e] + m[e];
	let g = h.slice(0, d * f), _ = new Int32Array(c.length);
	for (let e = 0; e < c.length; e++) {
		let t = c[e], n = p(t);
		_[g[n]++] = t;
	}
	return {
		indices: c,
		minX: i,
		minY: o,
		cs: u,
		cols: d,
		rows: f,
		cellStart: h,
		order: _,
		bounds: {
			minX: i,
			maxX: a,
			minY: o,
			maxY: s
		}
	};
}
function r(e, t) {
	let n = Math.max(0, Math.floor((t.minX - e.minX) / e.cs)), r = Math.min(e.cols - 1, Math.floor((t.maxX - e.minX) / e.cs)), i = Math.max(0, Math.floor((t.minY - e.minY) / e.cs)), a = Math.min(e.rows - 1, Math.floor((t.maxY - e.minY) / e.cs));
	return r < n || a < i ? null : {
		cx0: n,
		cx1: r,
		cy0: i,
		cy1: a
	};
}
function i(e, t, n, i) {
	let a = r(t, n);
	if (!a) return;
	let { cols: o, cellStart: s, order: c } = t;
	for (let t = a.cy0; t <= a.cy1; t++) {
		let r = t * o;
		for (let t = a.cx0; t <= a.cx1; t++) {
			let a = r + t;
			for (let t = s[a]; t < s[a + 1]; t++) {
				let r = c[t];
				e.x[r] >= n.minX && e.x[r] <= n.maxX && e.y[r] >= n.minY && e.y[r] <= n.maxY && i(r);
			}
		}
	}
}
function a(e, t) {
	let n = r(e, t);
	if (!n) return 0;
	let i = 0;
	for (let t = n.cy0; t <= n.cy1; t++) {
		let r = t * e.cols;
		for (let t = n.cx0; t <= n.cx1; t++) {
			let n = r + t;
			i += e.cellStart[n + 1] - e.cellStart[n];
		}
	}
	return i;
}
//#endregion
//#region src/bigmap/SkeletonMapReader.ts
var o = {
	minX: -Infinity,
	maxX: Infinity,
	minY: -Infinity,
	maxY: Infinity
};
function s(e, t, n) {
	let r = (1 - Math.abs(2 * n - 1)) * t, i = r * (1 - Math.abs(e / 60 % 2 - 1)), a = n - r / 2, o = 0, s = 0, c = 0;
	return e < 60 ? [o, s, c] = [
		r,
		i,
		0
	] : e < 120 ? [o, s, c] = [
		i,
		r,
		0
	] : e < 180 ? [o, s, c] = [
		0,
		r,
		i
	] : e < 240 ? [o, s, c] = [
		0,
		i,
		r
	] : e < 300 ? [o, s, c] = [
		i,
		0,
		r
	] : [o, s, c] = [
		r,
		0,
		i
	], [
		Math.round((o + a) * 255),
		Math.round((s + a) * 255),
		Math.round((c + a) * 255)
	];
}
var c = class {
	constructor(e) {
		this.viewportAware = !0, this.hashLookupCapable = !0, this.viewport = o, this.version = 0, this.planeCache = /* @__PURE__ */ new Map(), this.areaCache = /* @__PURE__ */ new Map(), this.rgbCache = /* @__PURE__ */ new Map(), this.visibleCache = /* @__PURE__ */ new Map(), this.detail = /* @__PURE__ */ new Map(), this.userDataMap = /* @__PURE__ */ new Map(), this.sk = e;
		let t = e.y;
		for (let n = 0; n < e.count; n++) t[n] = -t[n];
		for (let t of e.userData ?? []) this.userDataMap.set(t.id, t.data);
		for (let t of e.detailRooms ?? []) t.y = -t.y, this.isGrid(t.area) && (t.exits = {}, t.stubs = []), this.detail.set(t.id, t);
	}
	skeleton() {
		return this.sk;
	}
	getRoomIdByHash(e) {
		return this.sk.hashToId?.[e];
	}
	setViewport(e) {
		let t = this.viewport;
		e.minX === t.minX && e.maxX === t.maxX && e.minY === t.minY && e.maxY === t.maxY || (this.viewport = { ...e }, this.visibleCache.clear(), this.version++);
	}
	getViewport() {
		return this.viewport;
	}
	getPlaneRoomCount(e, t) {
		return this.planeIndex(e, t).indices.length;
	}
	estimateVisibleCount(e, t, n) {
		return a(this.planeIndex(e, t), n);
	}
	forEachInBounds(e, t, n, r) {
		let a = this.sk;
		i(a, this.planeIndex(e, t), n, (e) => r(a.x[e], a.y[e], a.env[e]));
	}
	getArea(e) {
		let t = this.areaCache.get(e);
		return t || (t = new l(e, this), this.areaCache.set(e, t)), t;
	}
	getAreas() {
		return [...new Set(Array.from(this.sk.area))].map((e) => this.getArea(e));
	}
	getRooms() {
		return [];
	}
	getRoom(e) {
		let t = this.detail.get(e);
		if (t) return t;
		if (!this.idIndex) {
			this.idIndex = /* @__PURE__ */ new Map();
			for (let e = 0; e < this.sk.count; e++) this.idIndex.set(this.sk.id[e], e);
		}
		let n = this.idIndex.get(e);
		return n === void 0 ? void 0 : this.makeRoom(n);
	}
	getColorValue(e) {
		let [t, n, r] = this.rgb(e);
		return `rgb(${t},${n},${r})`;
	}
	getSymbolColor(e, t) {
		let [n, r, i] = this.rgb(e), a = (Math.max(n, r, i) + Math.min(n, r, i)) / 2 / 255 > .41 ? "25,25,25" : "225,255,255", o = Math.min(Math.max(t ?? 1, 0), 1);
		return o === 1 ? `rgba(${a})` : `rgba(${a}, ${o})`;
	}
	getReaderVersion() {
		return this.version;
	}
	labelsFor(e, t) {
		return (this.sk.labels ?? []).filter((n) => n.areaId === e && n.Z === t);
	}
	isGrid(e) {
		return !!this.sk.areaGridMode[e];
	}
	rgb(e) {
		let t = this.rgbCache.get(e);
		if (!t) {
			let n = this.sk.customEnvColors[e];
			t = n ? [
				n.r,
				n.g,
				n.b
			] : s((e * 2654435761 >>> 0) % 360, .5, .55), this.rgbCache.set(e, t);
		}
		return t;
	}
	hashFor(e) {
		if (!this.sk.hashToId) return "";
		if (!this.idToHashIndex) {
			this.idToHashIndex = /* @__PURE__ */ new Map();
			for (let e in this.sk.hashToId) this.idToHashIndex.set(this.sk.hashToId[e], e);
		}
		return this.idToHashIndex.get(e) ?? "";
	}
	makeRoom(e) {
		let n = this.sk, r = this.detail.get(n.id[e]);
		if (r) return r;
		let i = {};
		if (!this.isGrid(n.area[e])) {
			let r = e * 12;
			for (let e = 0; e < 12; e++) {
				let a = n.exits[r + e];
				a !== -1 && (i[t[e]] = a);
			}
		}
		return {
			id: n.id[e],
			area: n.area[e],
			x: n.x[e],
			y: n.y[e],
			z: n.z[e],
			areaId: String(n.area[e]),
			weight: 1,
			roomChar: "",
			name: n.names?.[e] ?? "",
			userData: this.userDataMap.get(n.id[e]) ?? {},
			customLines: {},
			stubs: [],
			hash: this.hashFor(n.id[e]),
			env: n.env[e],
			exits: i,
			doors: {},
			specialExits: {}
		};
	}
	planeIndex(e, t) {
		let r = `${e}:${t}`, i = this.planeCache.get(r);
		return i || (i = n(this.sk, e, t), this.planeCache.set(r, i)), i;
	}
	visibleRooms(e, t) {
		let n = `${e}:${t}`, r = this.visibleCache.get(n);
		if (!r) {
			let a = [];
			i(this.sk, this.planeIndex(e, t), this.viewport, (e) => a.push(this.makeRoom(e))), r = a, this.visibleCache.set(n, r);
		}
		return r;
	}
}, l = class {
	constructor(e, t) {
		this.areaId = e, this.reader = t, this.planeCache = /* @__PURE__ */ new Map();
	}
	getAreaName() {
		return this.reader.skeleton().areaNames[this.areaId] ?? `#${this.areaId}`;
	}
	getAreaId() {
		return this.areaId;
	}
	getVersion() {
		return this.reader.getReaderVersion();
	}
	getPlane(e) {
		let t = this.planeCache.get(e);
		return t || (t = new u(this.areaId, e, this.reader), this.planeCache.set(e, t)), t;
	}
	getPlanes() {
		return this.getZLevels().map((e) => this.getPlane(e));
	}
	getZLevels() {
		let e = this.reader.skeleton(), t = /* @__PURE__ */ new Set();
		for (let n = 0; n < e.count; n++) e.area[n] === this.areaId && t.add(e.z[n]);
		return [...t].sort((e, t) => e - t);
	}
	getRooms() {
		return [];
	}
	getFullBounds() {
		let e = this.getZLevels(), t = {
			minX: Infinity,
			maxX: -Infinity,
			minY: Infinity,
			maxY: -Infinity
		};
		for (let n of e) {
			let e = this.reader.planeIndex(this.areaId, n).bounds;
			t = {
				minX: Math.min(t.minX, e.minX),
				maxX: Math.max(t.maxX, e.maxX),
				minY: Math.min(t.minY, e.minY),
				maxY: Math.max(t.maxY, e.maxY)
			};
		}
		return t;
	}
	getLinkExits(t) {
		if (this.reader.isGrid(this.areaId)) return [];
		let n = this.reader.visibleRooms(this.areaId, t);
		return n.length === 0 ? [] : Array.from(e(n).values()).filter((e) => e.zIndex.includes(t));
	}
}, u = class {
	constructor(e, t, n) {
		this.areaId = e, this.z = t, this.reader = n;
	}
	getRooms() {
		return this.reader.visibleRooms(this.areaId, this.z);
	}
	getLabels() {
		return this.reader.labelsFor(this.areaId, this.z);
	}
	getBounds() {
		let e = { ...this.reader.planeIndex(this.areaId, this.z).bounds };
		for (let t of this.reader.labelsFor(this.areaId, this.z)) {
			let n = t.X, r = -t.Y;
			e.minX = Math.min(e.minX, n), e.maxX = Math.max(e.maxX, n + t.Width), e.minY = Math.min(e.minY, r), e.maxY = Math.max(e.maxY, r + t.Height);
		}
		return e;
	}
};
//#endregion
export { t as a, i, n, a as r, c as t };

//# sourceMappingURL=SkeletonMapReader-ZPwsqemZ.js.map